/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AcademicUserDTO,
    AcademicUserDTOFromJSON,
    AcademicUserDTOFromJSONTyped,
    AcademicUserDTOToJSON,
} from './AcademicUserDTO';
import {
    AccreditationTypeEnum,
    AccreditationTypeEnumFromJSON,
    AccreditationTypeEnumFromJSONTyped,
    AccreditationTypeEnumToJSON,
} from './AccreditationTypeEnum';
import {
    FacultyDTO,
    FacultyDTOFromJSON,
    FacultyDTOFromJSONTyped,
    FacultyDTOToJSON,
} from './FacultyDTO';
import {
    GeographicLocationEnum,
    GeographicLocationEnumFromJSON,
    GeographicLocationEnumFromJSONTyped,
    GeographicLocationEnumToJSON,
} from './GeographicLocationEnum';
import {
    LearningCompetenceDTO,
    LearningCompetenceDTOFromJSON,
    LearningCompetenceDTOFromJSONTyped,
    LearningCompetenceDTOToJSON,
} from './LearningCompetenceDTO';
import {
    MasterCategoryEnum,
    MasterCategoryEnumFromJSON,
    MasterCategoryEnumFromJSONTyped,
    MasterCategoryEnumToJSON,
} from './MasterCategoryEnum';
import {
    StudyPlanStatusEnum,
    StudyPlanStatusEnumFromJSON,
    StudyPlanStatusEnumFromJSONTyped,
    StudyPlanStatusEnumToJSON,
} from './StudyPlanStatusEnum';
import {
    StudyProgramLangEnum,
    StudyProgramLangEnumFromJSON,
    StudyProgramLangEnumFromJSONTyped,
    StudyProgramLangEnumToJSON,
} from './StudyProgramLangEnum';
import {
    TeachingFormatEnum,
    TeachingFormatEnumFromJSON,
    TeachingFormatEnumFromJSONTyped,
    TeachingFormatEnumToJSON,
} from './TeachingFormatEnum';

/**
 * 
 * @export
 * @interface StudyProgramDTO
 */
export interface StudyProgramDTO {
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTO
     */
    numberECTS?: number;
    /**
     * 
     * @type {AccreditationTypeEnum}
     * @memberof StudyProgramDTO
     */
    accreditationType?: AccreditationTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTO
     */
    capacity?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    educaionalDomainISCED?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    codCOR?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    ocupationName?: string | null;
    /**
     * 
     * @type {GeographicLocationEnum}
     * @memberof StudyProgramDTO
     */
    geographicLocation?: GeographicLocationEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    mission?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    objective?: string | null;
    /**
     * 
     * @type {TeachingFormatEnum}
     * @memberof StudyProgramDTO
     */
    teachingFormat?: TeachingFormatEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    ancNoticeNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgramDTO
     */
    ancNoticeDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgramDTO
     */
    ancExpireDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgramDTO
     */
    aracisNoticeDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgramDTO
     */
    aracisExpireDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof StudyProgramDTO
     */
    lastEvaluationDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    externalEvaluationHistory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    ancFilePath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    aracisRequestPath?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    facultyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    universityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    domainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    facultyId?: string;
    /**
     * 
     * @type {FacultyDTO}
     * @memberof StudyProgramDTO
     */
    faculty?: FacultyDTO;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    domainId?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    programSupervisor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    programSupervisorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    programSupervisorId?: string | null;
    /**
     * 
     * @type {StudyProgramLangEnum}
     * @memberof StudyProgramDTO
     */
    language?: StudyProgramLangEnum;
    /**
     * 
     * @type {MasterCategoryEnum}
     * @memberof StudyProgramDTO
     */
    masterCategory?: MasterCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    masterCategoryDescription?: string | null;
    /**
     * 
     * @type {Array<AcademicUserDTO>}
     * @memberof StudyProgramDTO
     */
    programSupervisors?: Array<AcademicUserDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyProgramDTO
     */
    programProfessionalCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyProgramDTO
     */
    programTransversalCompetences?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyProgramDTO
     */
    learningKnowledgeOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyProgramDTO
     */
    learningSkillOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {Array<LearningCompetenceDTO>}
     * @memberof StudyProgramDTO
     */
    learningResponsabilityOutcome?: Array<LearningCompetenceDTO> | null;
    /**
     * 
     * @type {number}
     * @memberof StudyProgramDTO
     */
    programNumber?: number;
    /**
     * 
     * @type {StudyPlanStatusEnum}
     * @memberof StudyProgramDTO
     */
    status?: StudyPlanStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof StudyProgramDTO
     */
    isDualProgram?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StudyProgramDTO
     */
    partnerName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StudyProgramDTO
     */
    isEurAceCertified?: boolean;
}

export function StudyProgramDTOFromJSON(json: any): StudyProgramDTO {
    return StudyProgramDTOFromJSONTyped(json, false);
}

export function StudyProgramDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyProgramDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'numberECTS': !exists(json, 'numberECTS') ? undefined : json['numberECTS'],
        'accreditationType': !exists(json, 'accreditationType') ? undefined : AccreditationTypeEnumFromJSON(json['accreditationType']),
        'capacity': !exists(json, 'capacity') ? undefined : json['capacity'],
        'educaionalDomainISCED': !exists(json, 'educaionalDomainISCED') ? undefined : json['educaionalDomainISCED'],
        'codCOR': !exists(json, 'codCOR') ? undefined : json['codCOR'],
        'ocupationName': !exists(json, 'ocupationName') ? undefined : json['ocupationName'],
        'geographicLocation': !exists(json, 'geographicLocation') ? undefined : GeographicLocationEnumFromJSON(json['geographicLocation']),
        'mission': !exists(json, 'mission') ? undefined : json['mission'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'teachingFormat': !exists(json, 'teachingFormat') ? undefined : TeachingFormatEnumFromJSON(json['teachingFormat']),
        'ancNoticeNumber': !exists(json, 'ancNoticeNumber') ? undefined : json['ancNoticeNumber'],
        'ancNoticeDate': !exists(json, 'ancNoticeDate') ? undefined : (new Date(json['ancNoticeDate'])),
        'ancExpireDate': !exists(json, 'ancExpireDate') ? undefined : (new Date(json['ancExpireDate'])),
        'aracisNoticeDate': !exists(json, 'aracisNoticeDate') ? undefined : (new Date(json['aracisNoticeDate'])),
        'aracisExpireDate': !exists(json, 'aracisExpireDate') ? undefined : (new Date(json['aracisExpireDate'])),
        'lastEvaluationDate': !exists(json, 'lastEvaluationDate') ? undefined : (json['lastEvaluationDate'] === null ? null : new Date(json['lastEvaluationDate'])),
        'externalEvaluationHistory': !exists(json, 'externalEvaluationHistory') ? undefined : json['externalEvaluationHistory'],
        'ancFilePath': !exists(json, 'ancFilePath') ? undefined : json['ancFilePath'],
        'aracisRequestPath': !exists(json, 'aracisRequestPath') ? undefined : json['aracisRequestPath'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'universityName': !exists(json, 'universityName') ? undefined : json['universityName'],
        'domainName': !exists(json, 'domainName') ? undefined : json['domainName'],
        'facultyId': !exists(json, 'facultyId') ? undefined : json['facultyId'],
        'faculty': !exists(json, 'faculty') ? undefined : FacultyDTOFromJSON(json['faculty']),
        'domainId': !exists(json, 'domainId') ? undefined : json['domainId'],
        'programSupervisor': !exists(json, 'programSupervisor') ? undefined : json['programSupervisor'],
        'programSupervisorEmail': !exists(json, 'programSupervisorEmail') ? undefined : json['programSupervisorEmail'],
        'programSupervisorId': !exists(json, 'programSupervisorId') ? undefined : json['programSupervisorId'],
        'language': !exists(json, 'language') ? undefined : StudyProgramLangEnumFromJSON(json['language']),
        'masterCategory': !exists(json, 'masterCategory') ? undefined : MasterCategoryEnumFromJSON(json['masterCategory']),
        'masterCategoryDescription': !exists(json, 'masterCategoryDescription') ? undefined : json['masterCategoryDescription'],
        'programSupervisors': !exists(json, 'programSupervisors') ? undefined : (json['programSupervisors'] === null ? null : (json['programSupervisors'] as Array<any>).map(AcademicUserDTOFromJSON)),
        'programProfessionalCompetences': !exists(json, 'programProfessionalCompetences') ? undefined : (json['programProfessionalCompetences'] === null ? null : (json['programProfessionalCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programTransversalCompetences': !exists(json, 'programTransversalCompetences') ? undefined : (json['programTransversalCompetences'] === null ? null : (json['programTransversalCompetences'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningKnowledgeOutcome': !exists(json, 'learningKnowledgeOutcome') ? undefined : (json['learningKnowledgeOutcome'] === null ? null : (json['learningKnowledgeOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningSkillOutcome': !exists(json, 'learningSkillOutcome') ? undefined : (json['learningSkillOutcome'] === null ? null : (json['learningSkillOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'learningResponsabilityOutcome': !exists(json, 'learningResponsabilityOutcome') ? undefined : (json['learningResponsabilityOutcome'] === null ? null : (json['learningResponsabilityOutcome'] as Array<any>).map(LearningCompetenceDTOFromJSON)),
        'programNumber': !exists(json, 'programNumber') ? undefined : json['programNumber'],
        'status': !exists(json, 'status') ? undefined : StudyPlanStatusEnumFromJSON(json['status']),
        'isDualProgram': !exists(json, 'isDualProgram') ? undefined : json['isDualProgram'],
        'partnerName': !exists(json, 'partnerName') ? undefined : json['partnerName'],
        'isEurAceCertified': !exists(json, 'isEurAceCertified') ? undefined : json['isEurAceCertified'],
    };
}

export function StudyProgramDTOToJSON(value?: StudyProgramDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'numberECTS': value.numberECTS,
        'accreditationType': AccreditationTypeEnumToJSON(value.accreditationType),
        'capacity': value.capacity,
        'educaionalDomainISCED': value.educaionalDomainISCED,
        'codCOR': value.codCOR,
        'ocupationName': value.ocupationName,
        'geographicLocation': GeographicLocationEnumToJSON(value.geographicLocation),
        'mission': value.mission,
        'objective': value.objective,
        'teachingFormat': TeachingFormatEnumToJSON(value.teachingFormat),
        'ancNoticeNumber': value.ancNoticeNumber,
        'ancNoticeDate': value.ancNoticeDate === undefined ? undefined : (value.ancNoticeDate.toISOString()),
        'ancExpireDate': value.ancExpireDate === undefined ? undefined : (value.ancExpireDate.toISOString()),
        'aracisNoticeDate': value.aracisNoticeDate === undefined ? undefined : (value.aracisNoticeDate.toISOString()),
        'aracisExpireDate': value.aracisExpireDate === undefined ? undefined : (value.aracisExpireDate.toISOString()),
        'lastEvaluationDate': value.lastEvaluationDate === undefined ? undefined : (value.lastEvaluationDate === null ? null : value.lastEvaluationDate.toISOString()),
        'externalEvaluationHistory': value.externalEvaluationHistory,
        'ancFilePath': value.ancFilePath,
        'aracisRequestPath': value.aracisRequestPath,
        'facultyName': value.facultyName,
        'universityName': value.universityName,
        'domainName': value.domainName,
        'facultyId': value.facultyId,
        'faculty': FacultyDTOToJSON(value.faculty),
        'domainId': value.domainId,
        'programSupervisor': value.programSupervisor,
        'programSupervisorEmail': value.programSupervisorEmail,
        'programSupervisorId': value.programSupervisorId,
        'language': StudyProgramLangEnumToJSON(value.language),
        'masterCategory': MasterCategoryEnumToJSON(value.masterCategory),
        'masterCategoryDescription': value.masterCategoryDescription,
        'programSupervisors': value.programSupervisors === undefined ? undefined : (value.programSupervisors === null ? null : (value.programSupervisors as Array<any>).map(AcademicUserDTOToJSON)),
        'programProfessionalCompetences': value.programProfessionalCompetences === undefined ? undefined : (value.programProfessionalCompetences === null ? null : (value.programProfessionalCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programTransversalCompetences': value.programTransversalCompetences === undefined ? undefined : (value.programTransversalCompetences === null ? null : (value.programTransversalCompetences as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningKnowledgeOutcome': value.learningKnowledgeOutcome === undefined ? undefined : (value.learningKnowledgeOutcome === null ? null : (value.learningKnowledgeOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningSkillOutcome': value.learningSkillOutcome === undefined ? undefined : (value.learningSkillOutcome === null ? null : (value.learningSkillOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'learningResponsabilityOutcome': value.learningResponsabilityOutcome === undefined ? undefined : (value.learningResponsabilityOutcome === null ? null : (value.learningResponsabilityOutcome as Array<any>).map(LearningCompetenceDTOToJSON)),
        'programNumber': value.programNumber,
        'status': StudyPlanStatusEnumToJSON(value.status),
        'isDualProgram': value.isDualProgram,
        'partnerName': value.partnerName,
        'isEurAceCertified': value.isEurAceCertified,
    };
}

